function upcomingSessionsNav(){ 
	$('.upcoming-sessions-dates-nav .nav-slider-content').on('init', function(event, slick){
	    $active_date = $('.upcoming-sessions-dates-nav .slick-current.date-item').data('value');		

	    $('.upcoming-sessions-dates-nav .slick-current').addClass('active');
		$('.upcoming-sessions tbody[data-value="'+$active_date+'"]').show();
		$('.upcoming-sessions tbody[data-value!="'+$active_date+'"]').hide();
	});
	var upcomingDessionsDatesSlider = $('.upcoming-sessions-dates-nav .nav-slider-content').slick({
		slidesToShow: 6,
		slidesToScroll: 1,	    			 
		infinite:false,
		dots: false,
		focusOnSelect: true,
		arrows:true,
		nav:false,
		appendArrows: $('.upcoming-sessions-dates-nav '),
		prevArrow: '<a href="#" class="arrow-left"><svg width="20" height="32" viewBox="0 0 20 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7337 3.73333L16.0003 0L0 16L16.0003 32L19.7337 28.2667L7.4668 16L19.7337 3.73333Z"/></svg></a>',
		nextArrow: '<a href="#" class="arrow-right"><svg width="20" height="32" viewBox="0 0 20 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.266319 28.2667L3.99972 32L20 16L3.99972 0L0.266319 3.73333L12.5332 16L0.266319 28.2667Z"/></svg></a>',
		responsive: [
			{
		     	breakpoint: 1400,
				settings: {
					slidesToShow: 5,
				}
		    },
			{
		     	breakpoint: 1200,
				settings: {
					slidesToShow: 4,
				}
		    },
		    {
		     	breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				}
		    },
		    {
				breakpoint: 600,
				settings: {
					slidesToShow: 2
				}
		    },
		    {
				breakpoint: 420,
				settings: {
					slidesToShow: 1,
				}
		    }						    
	    ]
	});

}

function showSessions( $active_date , $this ){
	$('.upcoming-sessions-dates-nav .active.date-item').removeClass('active');
	$this.addClass('active');
	$('.upcoming-sessions tbody[data-value="'+$active_date+'"]').show();
	$('.upcoming-sessions tbody[data-value!="'+$active_date+'"]').hide();
	var slideno = $(this).data('slide');
	upcomingDessionsDatesSlider.slick('slickGoTo', slideno);
}
